import { Component, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DataStorageService } from "../../services/data-storage.service";
import { PetInsuranceData } from "../../models";
import { PetCardListComponent } from "../../modules/pet/pet-card-list/pet-card-list.component";

@Component({
  selector: 'cpf-select-pet-cards',
  templateUrl: './select-pet-cards-modal.component.html',
  styleUrls: ['./select-pet-cards-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectPetCardsModalComponent {
  @ViewChild(PetCardListComponent, { static: true }) petCardListComponent!: PetCardListComponent;
  selectedIndexes: number[] = [];
  pets: PetInsuranceData[] = [];

  constructor(public dialogRef: MatDialogRef<SelectPetCardsModalComponent>, @Inject(MAT_DIALOG_DATA) public data: {
    selectedContracts: string[]
  }, public dataStorageService: DataStorageService) {
    let baseNumbers = new Set<string>();
    dataStorageService.getAllData.forEach(contract=> {
      if (!baseNumbers.has(contract.base_number)){
        baseNumbers.add(contract.base_number);
        this.pets.push(contract);
      }

      if (data.selectedContracts.includes(contract.full_contract_number)){
        this.selectedIndexes.push(this.pets.length - 1);
      }
    });
  }

  onCardSelected(pet:PetInsuranceData){
    console.log(pet)
  }

  close() {
    this.dialogRef.close(this.pets.filter((pet, index) => this.petCardListComponent.selectedIndexes.includes(index)));
  }
}
